import { render, staticRenderFns } from "./ExpertDetail.vue?vue&type=template&id=2649c400&scoped=true"
import script from "./ExpertDetail.vue?vue&type=script&lang=js"
export * from "./ExpertDetail.vue?vue&type=script&lang=js"
import style0 from "./ExpertDetail.vue?vue&type=style&index=0&id=2649c400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2649c400",
  null
  
)

export default component.exports